import { ssoEligiblePage, title } from '@mixins';

export default {
  mixins: [title, ssoEligiblePage],
};
